import { gsap } from '../core/animation/gsap'

export const init = async function () {
  gsap.utils.toArray('.Slider-comparisonSection').forEach((element) => {
    const section: HTMLElement | null =
      element instanceof HTMLElement ? element : null

    if (section == null) {
      return
    }

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: section,
        start: 'center center',
        // makes the height of the scrolling (while pinning) match the width, thus the speed remains constant (vertical/horizontal)
        end: () => '+=' + section.offsetWidth,
        scrub: true,
        pin: true,
        anticipatePin: 1
      },
      defaults: { ease: 'none' }
    })

    // animate the container one way...
    tl.fromTo(
      section.querySelector('.Slider-afterImage'),
      { xPercent: 100, x: 0 },
      { xPercent: 0 }
    )
      // ...and the image the opposite way (at the same time)
      .fromTo(
        section.querySelector('.Slider-afterImage img'),
        { xPercent: -100, x: 0 },
        { xPercent: 0 },
        0
      )
      .fromTo(
        section.querySelector('.Slider-afterLabel'),
        { xPercent: -100, x: 0 },
        { xPercent: 0 },
        0
      )
  })
}
